import classNames from "classnames";
import React, { FunctionComponent, useMemo } from "react";
import { FormattedNumber } from "react-intl";
import CartTooltip from "@Components/atoms/cart/CartTooltip";
import { Price } from "@Types/api/price";
import "./style.scss";

interface Props {
  disabled: boolean;
  informativeMessage?: string;
  label: string;
  onDismiss?: () => void;
  total: Price;
}

const CartTotalLine: FunctionComponent<Props> = ({
  disabled,
  informativeMessage,
  label,
  onDismiss,
  total,
}) => {
  const informativeMessageElement = useMemo(
    () => (informativeMessage ? <CartTooltip info={informativeMessage} /> : null),
    [informativeMessage]
  );
  const dismissButton = useMemo(
    () =>
      onDismiss ? (
        <button className="CartTotalLine-dismissButton" onClick={onDismiss} disabled={disabled}>
          X
        </button>
      ) : null,
    [onDismiss, disabled]
  );

  return (
    <div className="CartTotalLine">
      <div className="CartTotalLine-label">{label}</div>
      <div
        className={classNames("CartTotalLine-value", {
          "CartTotalLine-value--disabled": disabled,
        })}
      >
        <FormattedNumber value={total.cents / 100} style="currency" currency={total.currency} />
      </div>
      {informativeMessageElement}
      {dismissButton}
    </div>
  );
};

export default React.memo(CartTotalLine);
